import { useMutation } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';

export const useDeleteSchedule = () => {
  const authState = useAuthSelector();
  return useMutation((scheduleId: string) =>
    sdk.schedule.mutate.delete(scheduleId, authState?.auth_token),
  );
};
